import React from "react";

import "./styles.css";

import { useRoute, Link, DisabledPrompt, useParams, useModel } from "@bcm-dev/bcms-vite";
import { SVGAsset } from "res";
import { UIPrimaryButton } from "components/ui/UIButton";
import { Card } from "model";

export default function DigitalIssuanceConfirmView(props) {
  const navigate = useRoute();
  const { branding } = useModel();

  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const doneBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);
  const creditBranding = branding.options.loststolen_credit_chw23;
  const withoutIssuance = "self-service without digital issuance";
  const reasonForReportingCardLostOrStolen = useParams().reasonForReportingCardLostOrStolen ?? "";
  const selectedRecognizeTransactionsType = useParams().selectedRecognizeTransactionsType ?? "";
  const card = Card.initByID(cardID);
  let showMessageType1 = true;
  let showMessageType2 = false;

  // Branding will determine which message is shown.
  if(card.type === "credit" 
  && selectedRecognizeTransactionsType === "transactionsIDidNotMake" 
  && creditBranding === withoutIssuance) {
    showMessageType1 = false;
    showMessageType2 = true;
  } else if(card.type === "credit"
  && reasonForReportingCardLostOrStolen === "cardIsStolen"
  && creditBranding === withoutIssuance) {
    showMessageType1 = false;
    showMessageType2 = true;
  }

  return(
    <div className="digital-issuance-confirm-view text-center flex-container flex-vertical">
      <div className="framed-icon-container flex-height">
        <SVGAsset id="DocumentsAlertIcon" />
      </div>
      { showMessageType1 === true &&
      <div className="flex-height flex-container flex-vertical text-button-container">
        <p className="recurring-payments-text flex-height">To keep your card secure, we have now turned your card OFF. Recurring Payments set up on the card will go through.</p>
        <p className="contact-text flex-height">It is important that we speak to you. <DisabledPrompt><span><Link>Contact us</Link></span></DisabledPrompt> immediately to report transactions that you may not recognize and to receive a new card.</p>
        <div className="button-container flex-height">
          {/* This needs to route back to the credit card on recent transactions */}
          <UIPrimaryButton text="Done" onClick={ doneBtn } />
        </div>
      </div>
      }
      { showMessageType2 === true &&
      <div className="flex-height flex-container flex-vertical text-button-container">
        <p className="recurring-payments-text flex-height">Your card is turned OFF. Recurring payments will continue to be approved.</p>
        <p className="contact-text flex-height">Contact us immediately to receive a new card and review your recent transactions.</p><div className="button-container flex-height">
          {/* This needs to route back to the credit card on recent transactions */}
          <UIPrimaryButton text="Done" onClick={ doneBtn } />
        </div>
      </div>
      }
    </div>
  );
}